"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
exports.getStyleParamsWithDefaults = function (styleParams, getDefaultStyleParamsFunc) {
    var _a = getDefaultStyleParamsFunc(), defaults = _a.defaults, overrides = _a.overrides;
    return _.defaultsDeep(_.merge(_.cloneDeep(styleParams), overrides), defaults);
};
//# sourceMappingURL=getStyleParamsWithDefaults.js.map